import { render, staticRenderFns } from "./PackageEquipmentProducts.vue?vue&type=template&id=35f4f232"
import script from "./PackageEquipmentProducts.vue?vue&type=script&lang=js"
export * from "./PackageEquipmentProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports